const CARD_WIDTH = 300
const GAP_WIDTH = 12 // padding between cards
const MARGIN_WIDTH = 24 // padding on the container, outside of the cards

// Precompute the minimum widths for each number of columns
const getMinimumWidth = (cardsPerRow: number) =>
  cardsPerRow * CARD_WIDTH + (cardsPerRow - 1) * GAP_WIDTH

export const COLUMNS_MINIMUM_WIDTH: { [key: number]: number } = {
  1: getMinimumWidth(1),
  2: getMinimumWidth(2),
  3: getMinimumWidth(3),
  4: getMinimumWidth(4),
  5: getMinimumWidth(5),
}

export function calculateAutoLayoutColumnsForWidth(width: number): number {
  const availableWidth = width - MARGIN_WIDTH * 2 // remove the margin on the left and right

  if (availableWidth >= COLUMNS_MINIMUM_WIDTH[5]) return 5
  if (availableWidth >= COLUMNS_MINIMUM_WIDTH[4]) return 4
  if (availableWidth >= COLUMNS_MINIMUM_WIDTH[3]) return 3
  if (availableWidth >= COLUMNS_MINIMUM_WIDTH[2]) return 2
  if (availableWidth >= COLUMNS_MINIMUM_WIDTH[1]) return 1

  return 0
}
